(function () {
(($, Drupal1)=>{
    'use strict';
    Drupal1.behaviors.scrollBox = {
        attach: function(context, settings) {
            function checkScroll(scrollContainer) {
                const hasHorizontalScroll = scrollContainer.scrollWidth > scrollContainer.clientWidth;
                //console.log([scrollContainer.scrollLeft + scrollContainer.clientWidth, scrollContainer.scrollWidth])
                if (!hasHorizontalScroll) {
                    scrollContainer.parentNode.classList.remove('before');
                    scrollContainer.parentNode.classList.remove('after');
                    //console.log('Žádný horizontální scroll neexistuje.');
                    return;
                } else scrollContainer.parentNode.classList.add('after');
                if (scrollContainer.scrollLeft === 0) scrollContainer.parentNode.classList.remove('before');
                else if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1) scrollContainer.parentNode.classList.remove('after');
                else {
                    scrollContainer.parentNode.classList.add('before');
                    scrollContainer.parentNode.classList.add('after');
                //console.log('Jsi ve scrollu.');
                }
            }
            once('scroll-box', '.organization-structure-alphabet__link').forEach(function(element) {
                let buttonBefore = document.createElement('div');
                let buttonAfter = document.createElement('div');
                buttonBefore.className = 'before-arrow';
                buttonAfter.className = 'after-arrow';
                buttonBefore.addEventListener('click', function(e) {
                    element.scrollTo({
                        left: -500,
                        behavior: "smooth"
                    });
                });
                buttonAfter.addEventListener('click', function(e) {
                    element.scrollTo({
                        left: 500,
                        behavior: "smooth"
                    });
                });
                element.parentNode.appendChild(buttonBefore);
                element.parentNode.appendChild(buttonAfter);
                element.addEventListener('scroll', function() {
                    checkScroll(element);
                });
                window.addEventListener('resize', function() {
                    checkScroll(element);
                });
                checkScroll(element);
            });
        }
    };
})(jQuery, Drupal);

})();
//# sourceMappingURL=scroll-box.js.map
